import { iFIREBASE_CONFIG, iAPP_SETTINGS } from '@/types';

const {
    VUE_APP_FIREBASE_apiKey,
    VUE_APP_FIREBASE_authDomain,
    VUE_APP_FIREBASE_databaseURL,
    VUE_APP_FIREBASE_projectId,
    VUE_APP_FIREBASE_storageBucket,
    VUE_APP_FIREBASE_messagingSenderId,
    VUE_APP_FIREBASE_appId,
    VUE_APP_FIREBASE_measurementId,
    VUE_APP_FIREBASE_FUNCTIONS_REGION,
    VUE_APP_ADMIN_EMAIL_USERNAME,
    VUE_APP_NAME,
    VUE_APP_NAME_SHORT,
    VUE_APP_TAGLINE,
    VUE_APP_THEME_COLOR
} = process.env;

export const NODE_ENV: string = process.env.NODE_ENV;
export const superadmins: string[] = [VUE_APP_ADMIN_EMAIL_USERNAME];
export const function_region: string = VUE_APP_FIREBASE_FUNCTIONS_REGION;
export const instance_id: string = VUE_APP_FIREBASE_projectId;
export const firebase_config: iFIREBASE_CONFIG = {
    apiKey: VUE_APP_FIREBASE_apiKey,
    authDomain: VUE_APP_FIREBASE_authDomain,
    databaseURL: VUE_APP_FIREBASE_databaseURL,
    projectId: VUE_APP_FIREBASE_projectId,
    storageBucket: VUE_APP_FIREBASE_storageBucket,
    messagingSenderId: VUE_APP_FIREBASE_messagingSenderId,
    appId: VUE_APP_FIREBASE_appId,
    measurementId: VUE_APP_FIREBASE_measurementId
};
export const initial_app_settings: iAPP_SETTINGS = {
    app_title: VUE_APP_NAME_SHORT || "Cognizant Assist",
    app_subtitle: VUE_APP_TAGLINE || "Aspire to serve",
    page_contactus: "Contact us page",
    page_homepage: "",
    support_categories: ["General Support", "Others"],
    donation_categories: ["General", "Cash", "Food", "Clothes"],
    beneficiary_terms: "By submitting, I agree to below terms and conditions",
    donor_terms: "By submitting, I agree to below terms and conditions",
    volunteer_terms: "By submitting, I agree to below terms and conditions",
    terms_conditions: "Terms and Conditions to be configured, contact administrator",
    groups_customization: {
        parent1_singular: "root group",
        parent1_plural: "root groups",
        parent0_singular: "parent group",
        parent0_plural: "parent groups",
        group_singular: "group",
        group_plural: "groups"
    },
    filter: {
        hour_sla_level1: "00",
        min_sla_level1: "00",
        hour_sla_level2: "00",
        min_sla_level2: "00",
        day_sla_level1: 0,
        day_sla_level2: 0
    }
};